export default {"src":"/login-app/[GIT_HASH]/_next/static/media/launchpad.4f68e657.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};